
















import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import {bus} from "@/plugins/bus";

@Component({
  components: {

  }
})

export default class AlphabetList extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  numbers = [];
  navList = [];
  isSearchActive: boolean = false;

  @Prop() films: Film.IFilm[];

  mounted() {
    this.numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

    this.navList = [{
      symbol: 'a',
      available: false,
    },{
      symbol: 'b',
      available: false,
    },{
      symbol: 'c',
      available: false,
    },{
      symbol: 'd',
      available: false,
    },{
      symbol: 'e',
      available: false,
    },{
      symbol: 'f',
      available: false,
    },{
      symbol: 'g',
      available: false,
    },{
      symbol: 'h',
      available: false,
    },{
      symbol: 'i',
      available: false,
    },{
      symbol: 'j',
      available: false,
    },{
      symbol: 'k',
      available: false,
    },{
      symbol: 'l',
      available: false,
    },{
      symbol: 'm',
      available: false,
    },{
      symbol: 'n',
      available: false,
    },{
      symbol: 'o',
      available: false,
    },{
      symbol: 'p',
      available: false,
    },{
      symbol: 'q',
      available: false,
    },{
      symbol: 'r',
      available: false,
    },{
      symbol: 's',
      available: false,
    },{
      symbol: 't',
      available: false,
    },{
      symbol: 'u',
      available: false,
    },{
      symbol: 'v',
      available: false,
    },{
      symbol: 'w',
      available: false,
    },{
      symbol: 'x',
      available: false,
    },{
      symbol: 'y',
      available: false,
    },{
      symbol: 'z',
      available: false,
    }];

    this.availableNav();

    bus.$on('searchToggle', (open) => {
      if (!open) this.isSearchActive = false;
    });
  }

  toggleSearch() {
    this.isSearchActive = !this.isSearchActive;

    bus.$emit('searchToggle', this.isSearchActive);
  }

  availableNav() {
    this.navList.forEach(item => item.available = Boolean(this.findFilm(item)));
  }

  findFilm(item) {
    return this.films.find((film: Film.IFilm) => film.titleSort[0].toLowerCase() === item.symbol.toLowerCase());
  }

  navClick(item) {
    let currentFilm = this.findFilm(item);

    if (currentFilm) this.$emit('scrollToFilm', currentFilm?.id);
  }

  @Watch('films')
  onFilmFilter() {
    this.availableNav();
  }
}
